export default __webpack_public_path__ + "static/media/icons-project-directory.4e050965.svg";